<template>
	<div class="panel bgPanel mt1x cb mr1x ml1x" id="generateHistory">
		<div class="clearfix dateSys titleBar title-bg">
			<span class="fs14x" :title="getLanguageStr('word1480','发电历史')">{{getLanguageStr("word1480","发电历史")}}</span>
			<div class="fR dpIB_E vaM_E" @mouseleave="leave">
				<div class="cField tra-fast_E vaM_E posR">
					<button @mouseenter="paramChooiceShow" :title="getLanguageStr('word566','参数选择')" class="sizeS bdSub pl1x pr1x boxR hover-main">{{getLanguageStr('word566','参数选择')}}</button>
					<DeviceDetailParam ref="DeviceDetailParam" @selectArray="updateShowParamArray" @beingParamArray="beingParamArray"></DeviceDetailParam>
				</div>
				<div class="cField tra-fast_E vaM_E hover-cMain_E">
					<button id="prev" class="w2x fa fa-angle-left fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'}" @click="dateChange('perv')"></button>
					<vue-datepicker-local v-if="timeChoose[ActiveIndex].type ==='all'" v-model="rangeDate" format="YYYY" :local="local" class="sizeS lh20" disabled></vue-datepicker-local>
					<vue-datepicker-local v-else v-model="time" :format="timeChoose[ActiveIndex].format" ref="date" :local="local" class="sizeS lh20" @input="_showChartParam()" :disabled-date="disabledDate"></vue-datepicker-local>
					<button id="next" class="w2x fa fa-angle-right fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'||timeGetTime>=todayGetTime}" @click="dateChange('next')"></button>
				</div>
				<div class="classGroup cField_E bdSub_E tra-fast_E">
					<button type="button" :class="{active:ActiveIndex==index}" v-for="(item,index) in timeChoose" @click="_timePicker(item,index)" :key="index">{{item.datepicker}}</button>
				</div>
			</div>
		</div>
		<div class="mt1x emptyToken_EE posR">
			<loading v-if="isChart" class="chartLoading"></loading>
			<div v-if="!isChart && ActiveIndex==0" class="taC dpIB_E mr1x_E lh15 ">
				<div v-if="timeGetTime==todayGetTime"><span :title="$t('word727',['装机容量'])">{{$t("word727",["装机容量"])+":&nbsp;"}}</span><span :title="installedCapacity?convertData(installedCapacity,2,'k','Wp')[0]:'--'">{{installedCapacity?convertData(installedCapacity,2,'k','Wp')[0]:'--'}}</span></div>
				<div><span :title="getLanguageStr('word358','当日发电量')">{{getLanguageStr('word358','当日发电量')}}:</span>
					<span :title="detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'}}</span></div>
				<div v-if="fromChild=='detail'"><span :title="getLanguageStr('word1882','当日满发小时')">{{getLanguageStr('word1882','当日满发小时')+':&nbsp;'}}</span>
					<span v-if="detailData.statistics" :title="floatFix(detailData.statistics.fullPowerHoursDay,2,' h', false)">{{floatFix(detailData.statistics.fullPowerHoursDay,2," h", false)}}</span><span v-else>--</span></div>
				<div v-if="fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('word1725','当日辐照量')">{{getLanguageStr('word1725','当日辐照量')}}:</span>
					<span v-if="detailData.statistics&&detailData.statistics.irradiate!=null" :title="convertData(detailData.statistics.irradiate ,2,'k','Wh/㎡')[0]">{{convertData(detailData.statistics.irradiate ,2,'k','Wh/㎡')[0]}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" v-if="solarmanAndZh" onclick="statistic('A13','A1315')">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="timeGetTime<todayGetTime&&stage.loc.customer=='SOLARMAN'&&fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('plant_detail6','当日理论发电量')">{{getLanguageStr('plant_detail6','当日理论发电量')}}:</span>
					<span v-if="detailData.statistics&&detailData.statistics.theoreticalGeneration!=null" :title="convertData(detailData.statistics.theoreticalGeneration,2,'k','Wh')[0]">{{convertData(detailData.statistics.theoreticalGeneration,2,'k','Wh')[0]}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" onclick="statistic('A13','A1315')" v-if="userInfo.organization.areaId==44">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="timeGetTime<todayGetTime&&fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('word1726','当日PR')">{{getLanguageStr('word1726','当日PR')}}: </span>
					<span v-if="detailData.statistics&&detailData.statistics.pr!=null">{{floatFix(detailData.statistics.pr*100,2,'%')}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" v-if="solarmanAndZh" onclick="statistic('A13','A1315')">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="timeGetTime<todayGetTime&&stage.loc.customer=='SOLARMAN'&&fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('plant_detail9','当日CPR')">{{getLanguageStr('plant_detail9','当日CPR')}}: </span>
					<span v-if="detailData.statistics&&detailData.statistics.cpr!=null" :title="floatFix(detailData.statistics.cpr*100,2,'%')">{{floatFix(detailData.statistics.cpr*100,2,'%')}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" onclick="statistic('A13','A1315')" v-if="userInfo.organization.areaId==44">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
			</div>
			<div v-if="!isChart && ActiveIndex==1" class="taC dpIB_E mr1x_E">
				<div><span :title="getLanguageStr('word359','当月发电量')">{{getLanguageStr('word359','当月发电量')}}:</span> <span :title="detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'}}</span></div>
				<div v-if="fromChild=='detail'"><span :title="getLanguageStr('word1728','当月满发小时')">{{getLanguageStr('word1728','当月满发小时')+':&nbsp;'}}</span><span v-if="detailData.statistics" :title="floatFix(detailData.statistics.fullPowerHoursDay,2,' h')">{{floatFix(detailData.statistics.fullPowerHoursDay,2," h")}}</span><span v-else>--</span></div>
				<div v-if="fromChild=='detail' && StationType==='light'"><span :title="getLanguageStr('word1729','当月辐照量')">{{getLanguageStr('word1729','当月辐照量')}}:</span>
					<span v-if="detailData.statistics&&detailData.statistics.irradiate!=null" :title="convertData(detailData.statistics.irradiate ,2,'k','Wh/㎡')[0]">{{convertData(detailData.statistics.irradiate ,2,'k','Wh/㎡')[0]}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" v-if="solarmanAndZh" onclick="statistic('A13','A1321')">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="stage.loc.customer=='SOLARMAN'&&fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('plant_detail7','当月理论发电量')">{{getLanguageStr('plant_detail7','当月理论发电量')}}:</span>
					<span v-if="detailData.statistics&&detailData.statistics.theoreticalGeneration!=null" :title="convertData(detailData.statistics.theoreticalGeneration,2,'k','Wh')[0]">{{convertData(detailData.statistics.theoreticalGeneration,2,'k','Wh')[0]}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" onclick="statistic('A13','A1321')" v-if="userInfo.organization.areaId==44">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="fromChild=='detail' && StationType==='light'"><span :title="getLanguageStr('word1730','当月PR')">{{getLanguageStr('word1730','当月PR')}}: </span>
					<span v-if="detailData.statistics&&detailData.statistics.pr!=null">{{floatFix(detailData.statistics.pr*100,2,'%')}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" v-if="solarmanAndZh" onclick="statistic('A13','A1321')">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="stage.loc.customer=='SOLARMAN'&&fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('plant_detail10','当月CPR')">{{getLanguageStr('plant_detail10','当月CPR')}}: </span>
					<span v-if="detailData.statistics&&detailData.statistics.cpr!=null" :title="floatFix(detailData.statistics.cpr*100,2,'%')">{{floatFix(detailData.statistics.cpr*100,2,'%')}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" onclick="statistic('A13','A1321')" v-if="userInfo.organization.areaId==44">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
			</div>
			<div v-if="!isChart && ActiveIndex==2" class="taC dpIB_E mr1x_E">
				<div><span :title="getLanguageStr('word360','当年发电量')">{{getLanguageStr('word360','当年发电量')}}:</span> <span :title="detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'}}</span></div>
				<div v-if="fromChild=='detail'"><span :title="getLanguageStr('word1734','当年满发小时')">{{getLanguageStr('word1734','当年满发小时')+':&nbsp;'}}</span><span v-if="detailData.statistics" :title="floatFix(detailData.statistics.fullPowerHoursDay,2,' h')">{{floatFix(detailData.statistics.fullPowerHoursDay,2," h")}}</span><span v-else>--</span></div>
				<div v-if="fromChild=='detail' && StationType==='light'"><span :title="getLanguageStr('word1736','当年辐照量')">{{getLanguageStr('word1736','当年辐照量')}}:</span>
					<span v-if="detailData.statistics&&detailData.statistics.irradiate!=null" :title="convertData(detailData.statistics.irradiate ,2,'k','Wh/㎡')[0]">
						{{convertData(detailData.statistics.irradiate ,2,'k','Wh/㎡')[0]}}
					</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" v-if="solarmanAndZh" onclick="statistic('A13','A1327')">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="stage.loc.customer=='SOLARMAN'&&fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('plant_detail8','当年理论发电量')">{{getLanguageStr('plant_detail8','当年理论发电量')}}:</span>
					<span v-if="detailData.statistics&&detailData.statistics.theoreticalGeneration!=null" :title="convertData(detailData.statistics.theoreticalGeneration,2,'k','Wh')[0]">{{convertData(detailData.statistics.theoreticalGeneration,2,'k','Wh')[0]}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" onclick="statistic('A13','A1327')" v-if="userInfo.organization.areaId==44">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<div v-if="fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('word1737','当年PR')">{{getLanguageStr('word1737','当年PR')}}: </span>
					<span v-if="detailData.statistics&&detailData.statistics.pr!=null" :title="floatFix(detailData.statistics.pr*100,2,'%')">
						{{floatFix(detailData.statistics.pr*100,2,'%')}}
					</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" v-if="solarmanAndZh" onclick="statistic('A13','A1327')">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
			</div>
			<div v-if="!isChart && ActiveIndex==3" class="taC dpIB_E mr1x_E">
				<div><span :title="getLanguageStr('word912','总发电量')">{{getLanguageStr('word912','总发电量')}}:</span> <span :title="detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'">{{detailData.statistics?convertData(detailData.statistics.generationValue,2,'k','Wh')[0]:'--'}}</span></div>
				<div v-if="fromChild=='detail'"><span :title="getLanguageStr('word1742','总满发小时')">{{getLanguageStr('word1742','总满发小时')+':&nbsp;'}}</span><span v-if="detailData.statistics" :title="floatFix(detailData.statistics.fullPowerHoursDay,2,' h')">{{floatFix(detailData.statistics.fullPowerHoursDay,2," h")}}</span><span v-else>--</span></div>
				<div v-if="fromChild=='detail' && StationType==='light'">
					<span :title="getLanguageStr('word1744','总辐照量')">{{getLanguageStr('word1744','总辐照量')}}:</span>
					<span v-if="detailData.statistics&&detailData.statistics.irradiate!=null">{{convertData(detailData.statistics.irradiate ,2,'k','Wh/㎡')[0]}}</span>
					<span title="--" v-else>--<router-link class="cMain ml05x" to="/application/virtualWeatherStation" target="_blank" :title="$t('plant_detail11',['购买'])" v-if="solarmanAndZh" onclick="statistic('A13','A1333')">{{$t('plant_detail11',['购买'])}}</router-link></span>
				</div>
				<!--<div><span :title="getLanguageStr('word1743','总PR')">{{getLanguageStr('word1743','总PR')}}: </span><span :title="detailData.statistics&&detailData.statistics.pr!=null?floatFix(detailData.statistics.pr*100,2,'%'):'--'">{{detailData.statistics&&detailData.statistics.pr!=null?floatFix(detailData.statistics.pr*100,2,'%'):'--'}}</span></div>-->
			</div>
		</div>
		<div class="pb1x">
			<ChartLine v-if="ActiveIndex==0" :data="ChartData" :option="defChartMonthOption" class="w100pct" :chartClass="'h28x'" ref="chartLine"></ChartLine>
			<ChartColumn v-else :data="ChartData" :option="defChartMonthOption" class="w100pct h28x" :chartClass="'h28x'" ref="chartColumn"></ChartColumn>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import Loading from '@/components/common/ui/Loading';
import ChartLine from '@/components/common/chart/ChartLine.vue';
import ChartColumn from '@/components/common/chart/ChartColumn.vue';
import DeviceDetailParam from '@/view/device/device/part/DeviceDetailParam';// 详情
import * as equipmentApi from '@/api/maintain/plant/list';
import * as lib from '@/util/lib.js';
import {getLocal} from '@/util';
import {getLanguageStr} from '@/util/language.js';

export default {
	name: 'generateHistory',
	components: {Loading, ChartLine, ChartColumn, DeviceDetailParam},
	computed: {
		...mapGetters({
			isOpen: 'stationDetail/isOpen',
			weather: 'stationDetail/weather',
			preference: 'user/preference',
			userInfo: 'user/userInfo'
		}),
		timeGetTime () {
			let year = new Date(this.time).getFullYear();
			let month = new Date(this.time).getMonth() + 1;
			let day = new Date(this.time).getDate();
			if (this.ActiveIndex == 0) {
				return new Date(year + '/' + month + '/' + day).getTime();
			} else if (this.ActiveIndex == 1) {
				return new Date(year + '/' + month + '/01').getTime();
			} else if (this.ActiveIndex == 2) {
				return new Date(String(year)).getTime();
			}
		},
		todayGetTime () {
			// let year = new Date().getFullYear()
			// let month = new Date().getMonth() + 1
			// let day = new Date().getDate()
			// if (this.ActiveIndex == 0) {
			//	 return new Date(year + '/' + month + '/' + day).getTime()
			// } else if (this.ActiveIndex == 1) {
			//	 return new Date(year + '/' + month).getTime()
			// } else if (this.ActiveIndex == 2) {
			//	 return new Date(year).getTime()
			// }
			if (this.ActiveIndex == 0) {
				return new Date(this.datepicker_Ctrl_day).getTime();
			} else if (this.ActiveIndex == 1) {
				return new Date(this.datepicker_Ctrl_month).getTime();
			} else if (this.ActiveIndex == 2) {
				return new Date(this.datepicker_Ctrl_year).getTime();
			}
		}
	},
	watch: {
		isOpen (val) {
			if (!val) {
				this.ActiveIndex = 0;
				this.time = new Date();
			}
		},
		collectTime (v) {
			if (this.basicInfo.region) {
				this.$nextTick(() => {
					this.time = new Date(this.timeFormat(v.lastUpdateTime ? v.lastUpdateTime : new Date(), 'utc', '%Y/%m/%d', {offset: this.basicInfo.region.timezone}));
				});
			}
		},
		baseInfo (v) {
			this.$nextTick(() => {
				this.time = new Date(this.timeFormat(this.collectTime.lastUpdateTime ? this.collectTime.lastUpdateTime : new Date(), 'utc', '%Y/%m/%d', {offset: v.region.timezone}));
			});
		}
	},
	props: {
		collectTime: Object,
		timeZoneCode: String,
		fromChild: {
			type: String,
			default: 'detail'
		},
		StationType: {
			type: String,
			default: 'light'
		}
	},
	data () {
		return {
			stage,
			option: {
				timeZoneCode: this.timeZoneCode
			},
			ActiveIndex: 0,
			solarmanAndZh: false,
			local: {},
			isChart: true, // 图表数据是否加载完成
			time: new Date(),
			rangeDate: [new Date('2000'), new Date()],
			datepicker_Ctrl_day: '',
			datepicker_Ctrl_month: '',
			datepicker_Ctrl_year: '',
			timeChoose: [{
				datepicker: getLanguageStr('cmd93', '日'),
				format: 'YYYY/MM/DD',
				type: 'day'
			}, {
				datepicker: getLanguageStr('cmd95', '月'),
				format: 'YYYY/MM',
				type: 'month'
				// },{
				//	datepicker:getLanguageStr("word1195","季度"),
				//	format:'YYYY/MM',
				//	type:'quarter'
			}, {
				datepicker: getLanguageStr('cmd96', '年'),
				format: 'YYYY',
				type: 'year'
			}, {
				datepicker: getLanguageStr('cmd97', '总'),
				format: 'YYYY',
				type: 'all'
			}],
			defChartMonthOption: {},
			ChartData: [], // 图标数据,
			detailData: {},
			tempData: [],
			chartList: [],
			stationId: null,
			systemId: null,
			level: 0,
			installedCapacity: null,
			// region:'PRC',
			basicInfo: {},
			isToday: false
		};
	},
	created () {
		this._getLocal();
	},
	methods: {
		getLanguageStr,
		floatFix: lib.floatFix,
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		convertData: lib.convertData,
		tempChange: lib.tempChange,
		leave () {
			this.paramChooiceActive = false;
			this.$refs.DeviceDetailParam.showParam = false;
		},
		show (data) {
			if (stage.loc.customer == 'SOLARMAN' && this.userInfo.organization.areaId == 44) {
				this.solarmanAndZh = true;
			} else {
				this.solarmanAndZh = false;
			}
			this.basicInfo = data.basicInfo;
			this.option.timeZoneCode = data.basicInfo.region.timezone || stage.time.timeZoneCode;
			if (this.basicInfo.region) {
				let lastDay = this.timeFormat(this.collectTime.lastUpdateTime ? this.collectTime.lastUpdateTime : new Date(), 'utc', '%Y/%m/%d', {offset: this.basicInfo.region.timezone});
				this.time = new Date(lastDay);

				this.datepicker_Ctrl_day = lastDay;
				this.datepicker_Ctrl_month = this.timeFormat(this.time, 'utc', '%Y/%m/01', {offset: this.basicInfo.region.timezone});
				this.datepicker_Ctrl_year = this.timeFormat(this.time, 'utc', '%Y', {offset: this.basicInfo.region.timezone});
				// console.log(this.datepicker_Ctrl_day)
				// console.log(this.datepicker_Ctrl_month)
				// console.log(this.datepicker_Ctrl_year)
			}
			this.installedCapacity = data.basicInfo.installedCapacity;
			this.stationId = data.stationId;
			this.systemId = data.systemId;
			this.level = data.level;
			this._showChart();
		},
		_getLocal () {
			this.local = getLocal();
		},
		disabledDate (time) {
			// let day = new Date().getTime()
			let day = new Date(this.datepicker_Ctrl_day).getTime();
			return day < time;
		},
		paramChooiceShow () {
			let chooseType = this.timeChoose[this.ActiveIndex].type;
			switch (chooseType) {
			case 'month':
				statistic('A13', 'A1319');
				break;
			case 'year':
				statistic('A13', 'A1325');
				break;
			case 'all':
				statistic('A13', 'A1331');
				break;
			default:
				statistic('A13', 'A1313');
			}
			let cloneChart = _.cloneDeep(this.chartList);
			if (cloneChart.length > 0) {
				cloneChart.forEach(el => {
					el.isBeingSelected = el.default;
				});
			}
			this.$refs.DeviceDetailParam.show(_.cloneDeep(this.chartList), cloneChart, true);
		},
		// 参数选择
		beingParamArray (data) {
			this.chartList = [];
			this.chartList = data;
		},
		updateShowParamArray (data) {
			let statisticType = data.filter(item => item.isBeingSelected).map(item => item.type);
			this.chartList = [];
			this.chartList = data;
			if (this.ActiveIndex == 0) {
				statistic('A13', 'A1314', 'select_production_day_parameters', statisticType);
				this._getDayData();
			} else if (this.ActiveIndex == 1) {
				statistic('A13', 'A1320', 'select_production_month_parameters', statisticType);
				this._getMonthData();
			} else if (this.ActiveIndex == 2) {
				statistic('A13', 'A1326', 'select_production_year_parameters', statisticType);
				this._getYearData();
			} else {
				statistic('A13', 'A1332', 'select_production_total_parameters', statisticType);
				this._getTotalData();
			}
		},
		// 时区转换成毫秒
		mz () {
			return stage.time.timezoneMap[this.basicInfo.region.timezone].offset * 1000;
		},
		// 日历
		dateChange (str) {
			// type day(日) week(周) month(月) year(年) all(总)
			let type = this.timeChoose[this.ActiveIndex].type;
			let val = this.$refs.date.text;
			// var date=new Date(val);
			// let today = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
			// let month = `${new Date().getFullYear()}-${new Date().getMonth() + 1}`
			// let year = `${new Date().getFullYear()}`
			// if(new Date(val).getTime()<new Date(today).getTime()){
			var date = new Date(type == 'month' || type == 'quarter' ? val.split('~').pop() + '/01' : val.split('~').pop());
			let step;
			switch (type) {
			case 'day':
				if (str === 'perv') {
					statistic('A13', 'A1316');
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(this.datepicker_Ctrl_day).getTime()) {
					statistic('A13', 'A1318');
					step = 1;
				} else {
					statistic('A13', 'A1317');
					step = 0;
				}
				// var step = str === 'next'&&new Date(val).getTime()<new Date(this.datepicker_Ctrl_day).getTime() ? 1: -1
				date.setDate(date.getDate() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'month':
				val += '/01'; // Firefox的new Date不能解析月格式 “2019/10”，需要加日期 01
				if (str === 'perv') {
					statistic('A13', 'A1322');
					step = -1;
				} else if (str === 'next' && new Date(val.replace(/\//g, '-')).getTime() < new Date(this.datepicker_Ctrl_month).getTime()) {
					statistic('A13', 'A1324');
					step = 1;
				} else {
					step = 0;
				}
				date.setMonth(date.getMonth() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'quarter':
				if (str === 'perv') {
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(this.datepicker_Ctrl_day).getTime()) {
					step = 1;
				} else {
					step = 0;
				}
				this.curQuarter = Math.ceil((date.getMonth() + 1 + step) / 3);
				date.setMonth(date.getMonth() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'year':
				if (str === 'perv') {
					statistic('A13', 'A1328');
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(this.datepicker_Ctrl_year).getTime()) {
					statistic('A13', 'A1330');
					step = 1;
				} else {
					step = 0;
				}
				date.setFullYear(date.getFullYear() + step);
				this.$refs.date.selectOk(date);
				break;
			default:
				break;
			}
		},
		// 获取天数
		_getCountDays () {
			let curDate = _.cloneDeep(this.time);
			// let curMonth =curDate.getMonth()
			// curDate.setMonth(curMonth+1)
			// curDate.setDate(0);
			// return curDate.getDate()
			let curMonth = curDate.getMonth() + 1;
			let curYear = curDate.getFullYear();
			return new Date(curYear, curMonth, 0).getDate();
		},
		_showChartParam () {
			if (this.ActiveIndex == 0) { // 日
				this._chartDay();
			} else if (this.ActiveIndex == 1) { // 月图表
				this._chartMonth();
			} else if (this.ActiveIndex == 2) { // 年
				this._chartYear();
			} else if (this.ActiveIndex == 3) { // 总
				this._totalData();
			}
		},
		// 曲线图
		_showChart () {
			this.detailData = {};
			this.isChart = true;
			this.chartList = {};
			for (let attr in this.proportion) {
				this.proportion[attr] = 0;
			}
			// 日曲线图
			if (this.ActiveIndex == 0) { // 日
				let arrDay = [
					{
						name: getLanguageStr('word176', '发电功率'),
						type: 'generationPower',
						selected: true,
						isBeingSelected: true,
						default: true,
						unit: 'W',
						data: []
					},
					{
						name: getLanguageStr('word1470', '天气'),
						type: 'weatherPic',
						dataType: 'weatherPic',
						selected: true,
						isBeingSelected: true,
						default: true,
						unit: '',
						data: []
					},
					{
						name: getLanguageStr('word1623', '当地温度'),
						type: 'temperature',
						selected: false,
						isBeingSelected: false,
						unit: this.preference.tempUnit == 1 ? '℃' : '℉',
						default: false,
						data: []
					},
					{
						name: getLanguageStr('word1211', '辐照强度'),
						type: 'irradiateIntensity', // irradiate
						selected: false,
						isBeingSelected: false,
						default: false,
						unit: 'W/㎡',
						data: []
					}
				];
				if (this.fromChild == 'childDetail') {
					arrDay = arrDay.slice(0, -1);
				}
				if (this.StationType === 'wind') {
					arrDay = [{
						name: getLanguageStr('word176', '发电功率'),
						type: 'generationPower',
						selected: true,
						isBeingSelected: true,
						default: true,
						unit: 'W',
						data: []
					}];
				}
				this.chartList = arrDay;
				this._chartDay();
			} else if (this.ActiveIndex == 1) { // 月图表
				let dateNum = this._getCountDays();
				let arrMonth = [
					{
						name: getLanguageStr('word358', '当日发电量'),
						unit: 'kWh',
						type: 'generationValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(dateNum)
					}, {
						name: getLanguageStr('word1882', '当日满发小时'),
						unit: 'h',
						type: 'fullPowerHoursDay',
						selected: false,
						isBeingSelected: false,
						default: false,
						data: new Array(dateNum)
					},
					{
						name: getLanguageStr('plant_detail216', '当日天气'),
						type: 'weatherPic',
						dataType: 'weatherPic',
						selected: true,
						isBeingSelected: true,
						default: true,
						unit: '',
						data: new Array(dateNum)
					},
					{
						name: getLanguageStr('word1731', '当日温度'),
						unit: this.preference.tempUnit == 1 ? '℃' : '℉',
						type: 'temperature',
						selected: false,
						isBeingSelected: false,
						default: false,
						data: new Array(dateNum)
					},
					{
						name: getLanguageStr('word1725', '当日辐照量'),
						unit: 'kWh/㎡',
						type: 'irradiate',
						selected: false,
						isBeingSelected: false,
						default: false,
						data: new Array(dateNum)
					},
					{
						name: getLanguageStr('plant_detail6', '当日理论发电量'),
						unit: 'kWh',
						type: 'theoreticalGeneration',
						selected: false,
						isBeingSelected: false,
						default: false,
						onlySolarman: true,
						data: new Array(dateNum)
					}, {
						name: getLanguageStr('word1726', '当日PR'),
						unit: '%',
						type: 'pr',
						selected: false,
						isBeingSelected: false,
						default: false,
						data: new Array(dateNum)
					},
					{
						name: getLanguageStr('plant_detail9', '当日CPR'),
						unit: '%',
						type: 'cpr',
						selected: false,
						isBeingSelected: false,
						default: false,
						onlySolarman: true,
						data: new Array(dateNum)
					}
				];
				if (this.StationType === 'wind') {
					arrMonth = [ {
						name: getLanguageStr('word358', '当日发电量'),
						unit: 'kWh',
						type: 'generationValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(dateNum)
					}, {
						name: getLanguageStr('word1882', '当日满发小时'),
						unit: 'h',
						type: 'fullPowerHoursDay',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(dateNum)
					}];
				}
				if (this.fromChild == 'childDetail') {
					if (this.StationType === 'wind') {
						arrMonth = [
							{
								name: getLanguageStr('word358', '当日发电量'),
								unit: 'kWh',
								type: 'generationValue',
								selected: true,
								isBeingSelected: true,
								default: true,
								data: new Array(dateNum)
							}
						];
					} else {
						arrMonth = [
							{
								name: getLanguageStr('word358', '当日发电量'),
								unit: 'kWh',
								type: 'generationValue',
								selected: true,
								isBeingSelected: true,
								default: true,
								data: new Array(dateNum)
							},
							{
								name: getLanguageStr('word1732', '当日天气'),
								type: 'weatherPic',
								dataType: 'weatherPic',
								selected: true,
								isBeingSelected: true,
								default: true,
								unit: '',
								data: new Array(dateNum)
							},
							{
								name: getLanguageStr('word1731', '当日温度'),
								unit: '℃',
								type: 'temperature',
								selected: false,
								isBeingSelected: false,
								default: false,
								data: new Array(dateNum)
							}
						];
					}
				}
				this.chartList = arrMonth;
				// this.chartList={
				//		 generationValue:{
				//				 name:getLanguageStr("word358","当日发电量"),
				//				 unit:"kWh",
				//				 data:new Array(dateNum)
				//		 },
				//		 fullPowerHoursDay:{
				//				 name:getLanguageStr("word1882","当日满发小时"),
				//		unit:"h",
				//		yAxis:1,
				//				 data:new Array(dateNum)
				//		 },
				//		 gridPowerCurve:{
				//				 name:getLanguageStr("word1731","当日温度"),
				//				 unit:"℃",
				//				 data:[]
				//		 },
				//		 gridPowerCurve:{
				//				 name:getLanguageStr("word1732","当日天气"),
				//				 unit:"W",
				//				 data:[]
				//		 },
				//		 irradiate:{
				//				 name:getLanguageStr("word1725","当日辐照量"),
				//		unit:"kWh/㎡",
				//		yAxis:2,
				//				 data:new Array(dateNum)
				//		 },
				//		 pr:{
				//				 name:getLanguageStr('word1726','当日PR'),
				//		unit:"%",
				//		yAxis:3,
				//				 data:new Array(dateNum)
				//		 }
				// }
				this._chartMonth();
			}
			// else if(this.ActiveIndex==2){	 //季度
			// let curDate = _.cloneDeep(this.time)
			// this.curQuarter = Math.ceil((curDate.getMonth()+1)/3)
			// if(this.assignInfo.gridInterconnectionType !=='EXCESS'){
			//	this.chartList={
			//		generation:{
			//			name:getLanguageStr("word359","当月发电量"),
			//			unit:"kWh",
			//			data:new Array(3)
			//		},
			//		income:{
			//			name:getLanguageStr("plant295","当月预估收入"),
			//			unit:"CNY",
			//			yAxis:1,
			//			data:new Array(3)
			//		},
			//		fullPowerHours:{
			//			name:getLanguageStr('word1728','当月满发小时'),
			//			unit:"h",
			//			yAxis:2,
			//			data:new Array(3)
			//		}
			//	}
			// }else{
			//	this.chartList={
			//		generation:{
			//			name:getLanguageStr("word359","当月发电量"),
			//			unit:"kWh",
			//			data:new Array(3)
			//		},
			//		income:{
			//			name:getLanguageStr("plant295","当月预估收入"),
			//			unit:"CNY",
			//			yAxis:1,
			//			data:new Array(3)
			//		},
			//		fullPowerHours:{
			//			name:getLanguageStr('word1728','当月满发小时'),
			//			unit:"h",
			//			yAxis:2,
			//			data:new Array(3)
			//		},
			//		consumption:{
			//			name:getLanguageStr("word528","当月用电量"),
			//			unit:"kWh",
			//			data:new Array(3)
			//		}
			//	}
			// }
			// this._charQuarter()
			// }
			else if (this.ActiveIndex == 2) { // 年
				let arrYear = [
					{
						name: getLanguageStr('word359', '当月发电量'),
						unit: 'kWh',
						type: 'generationValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(12)
					}, {
						name: getLanguageStr('word1728', '当月满发小时'),
						unit: 'h',
						type: 'fullPowerHoursDay',
						selected: false,
						isBeingSelected: false,
						default: false,
						data: new Array(12)
					}, {
						name: getLanguageStr('word1729', '当月辐照量'),
						unit: 'kWh/㎡',
						type: 'irradiate',
						selected: false,
						isBeingSelected: false,
						default: false,
						data: new Array(12)
					}, {
						name: getLanguageStr('plant_detail7', '当月理论发电量'),
						unit: 'kWh',
						type: 'theoreticalGeneration',
						selected: false,
						isBeingSelected: false,
						default: false,
						onlySolarman: true,
						data: new Array(12)
					}, {
						name: getLanguageStr('word1730', '当月PR'),
						unit: '%',
						type: 'pr',
						selected: false,
						isBeingSelected: false,
						default: false,
						data: new Array(12)
					}, {
						name: getLanguageStr('plant_detail10', '当月CPR'),
						unit: '%',
						type: 'cpr',
						selected: false,
						isBeingSelected: false,
						default: false,
						onlySolarman: true,
						data: new Array(12)
					}
				];
				if (this.StationType === 'wind') {
					arrYear = [{
						name: getLanguageStr('word359', '当月发电量'),
						unit: 'kWh',
						type: 'generationValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(12)
					}, {
						name: getLanguageStr('word1728', '当月满发小时'),
						unit: 'h',
						type: 'fullPowerHoursDay',
						selected: true,
						isBeingSelected: true,
						default: true,
						data: new Array(12)
					}];
				}
				if (this.fromChild == 'childDetail') {
					arrYear = arrYear.slice(0, 1);
				}
				this.chartList = arrYear;
				this._chartYear();
			} else if (this.ActiveIndex == 3) { // 总
				this._totalData();
			}
		},
		// 日图表其他数据
		powerDay () {
			let requestId;
			let chooseDay = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1,
				'day': this.time.getDate()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			return new Promise((resolve, reject) => {
				equipmentApi.PowerDayHistory(requestId, chooseDay).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 日图表天气接口
		powerDayTemp () {
			let request = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1,
				'day': this.time.getDate(),
				'regionNationId': this.basicInfo.region.nationId,
				'regionLevel1': this.basicInfo.region.level1,
				'regionLevel2': this.basicInfo.region.level2,
				timezone: this.basicInfo.region.timezone
			};
			return new Promise((resolve, reject) => {
				equipmentApi.WeatherDayHistory(request).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 整合日图表数据
		_getDayData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				/// //////////////////////////////////////////////////////////////////////////
				// chartData.push({//加入天气
				//	name:"天气",
				//	type:"weatherPic",
				//	dataType:"weatherPic"
				// });
				for (let attr in chartData) {
					chartData[attr].data = [];
					if (chartData[attr].type == 'weatherPic') { // 处理天气类型
						this.tempData.forEach(val => {
							chartData[attr].data.push([val.datetime * 1000 + this.mz(), null, val[chartData[attr].type]]);
						});
					} else if (chartData[attr].type == 'temperature') {
						if (this.tempData.length) {
							this.tempData.forEach(val => {
								chartData[attr].data.push([val.datetime * 1000 + this.mz(), val.temp]);
							});
						}
					} else {
						if (this.detailData.records.length) {
							this.detailData.records.forEach((val, index) => {
								if (val[chartData[attr].type] != null) {
									if (chartData[attr].type == 'irradiateIntensity') {
										if (val[chartData[attr].type] != null) {
											chartData[attr].data.push([val.dateTime * 1000 + this.mz(), val[chartData[attr].type]]);
										}
									} else {
										chartData[attr].data.push([val.dateTime * 1000 + this.mz(), val[chartData[attr].type]]);
									}
								}
							});
							chartData[attr].data = lib.sortData(chartData[attr].data, {byKey: 0});
						}
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) < 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					} else this.ChartData[attr].yAxis = 0;
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				if (yTitle.length == 0) {
					yTitle = [''];
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						opposite: true
					};
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
		},
		resetChart () {
			this.detailData = {};
			this.tempData = [];
			this.chartData = [];
		},
		// 日图表数据
		_chartDay () {
			this.$refs.chartLine.showLoading();
			let reqArr = [];
			if (this.StationType == 'light') {
				reqArr = [this.powerDay(), this.powerDayTemp()];
			} else {
				reqArr = [this.powerDay()];// 风力电站不再请求天气数据、（详见PRD1.4.0版本）
			}
			Promise.all(reqArr).then(response => {
				if (reqArr.length == 2) {
					if (response[1] && response[1].length > 0) {
						response[1] = response[1].map(item => {
							item.temp = this.tempChange(this.preference.tempUnit, item.temp)[1];
							return item;
						});
					}
				}
				if (this.timeChoose[this.ActiveIndex].type == 'day') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					if (this.$refs.chartLine) this.$refs.chartLine.hideLoading();
					this.isChart = false;
					this.detailData = response[0];
					if (reqArr.length == 2) {
						this.tempData = response[1];
						if (response[0].records.length == 0 && response[1].length == 0) {
							this.ChartData = [];
						} else {
							this._getDayData();
						}
					} else {
						if (response[0].records.length == 0) {
							this.ChartData = [];
						} else {
							this._getDayData();
						}
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartLine.hideLoading();
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
			// equipmentApi.cancelRequest()
		},
		// 月图表其他数据
		powerMonth () {
			let requestId;
			let chooseDay = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			return new Promise((resolve, reject) => {
				equipmentApi.PowerMonthHistory(requestId, chooseDay).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 月图表温度接口
		powerMonthTemp () {
			let request = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1,
				'regionNationId': this.basicInfo.region.nationId,
				'regionLevel1': this.basicInfo.region.level1,
				'regionLevel2': this.basicInfo.region.level2,
				timezone: this.basicInfo.region.timezone
			};
			return new Promise((resolve, reject) => {
				equipmentApi.WeatherMonthHistory(request).then(res => {
					resolve(res);
				}, error => {
					reject(error);
				});
			});
		},
		// 整合月数据
		_getMonthData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				let dateNum = this._getCountDays();
				for (let attr in chartData) {
					chartData[attr].data = new Array(dateNum);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					if (chartData[attr].type == 'weatherPic') { // 处理天气类型
						this.tempData.forEach(val => {
							chartData[attr].data[Number(lib.timeFormat(val.datetime, 'utc', '%d', {offset: this.option.timeZoneCode})) - 1] = val.weatherPic;
						});
					} else if (chartData[attr].type == 'temperature') {
						if (this.tempData.length) {
							this.tempData.forEach(val => {
								chartData[attr].data[Number(lib.timeFormat(val.datetime, 'utc', '%d', {offset: this.option.timeZoneCode})) - 1] = Number(val.temp);
							});
						}
					} else if (chartData[attr].type == 'pr') {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.day) - 1] = Number(val[chartData[attr].type]) * 100;
							}
						});
					} else if (chartData[attr].type == 'cpr') {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.day) - 1] = Number(val[chartData[attr].type]) * 100;
							}
						});
					} else {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.day) - 1] = Number(val[chartData[attr].type]);
							}
						});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) < 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				if (yTitle.length == 0) {
					yTitle = [''];
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'month',
						opposite: true,
						xCategories: new Array(dateNum)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + 1;
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
		},
		// 月图表数据
		_chartMonth () {
			this.$refs.chartColumn.showLoading();
			let reqArr = [];
			if (this.StationType == 'light') {
				reqArr = [this.powerMonth(), this.powerMonthTemp()];
			} else {
				reqArr = [this.powerMonth()];// 风力电站不再请求天气数据、（详见PRD1.4.0版本）
			}
			Promise.all(reqArr).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'month') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					if (reqArr.length == 2) {
						if (response[1] && response[1].length > 0) {
							response[1] = response[1].map(item => {
								item.temp = this.tempChange(this.preference.tempUnit, item.temp)[1];
								return item;
							});
						}
					}
					this.isChart = false;
					this.detailData = response[0];
					if (reqArr.length == 2) {
						this.tempData = response[1];
						if (response[0].records.length == 0 && response[1].length == 0) {
							this.ChartData = [];
						} else {
							this._getMonthData();
						}
					} else {
						if (response[0].records.length == 0) {
							this.ChartData = [];
						} else {
							this._getMonthData();
						}
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 季度图表
		// _charQuarter(){
		//	lib.loadingChange($("#chartColumn [Loading]"),true);
		//	let chooseQuarter={
		//		year:lib.timeFormat(this.time,"inc",'%Y'),
		//		quarter: this.curQuarter
		//	}
		//	// equipmentApi.cancelRequest()
		//	equipmentApi.PowerQuarterHistory(this.stationId,chooseQuarter.year,chooseQuarter.quarter).then(response=>{
		//		this.isChart=false
		//		if(!response)return
		//		lib.loadingChange($("#chartColumn [Loading]"),false);
		//		this.detailData=response
		//		if(this.detailData.data.length==0){
		//			this.ChartData=[];
		//		}else{
		//			let n = (this.curQuarter-1)*3+1
		//			for(let attr in this.chartList){
		//				$.each(this.chartList[attr].data,(index)=>{
		//					this.chartList[attr].data[index]=null
		//				})
		//				this.detailData.data.map((val,index)=>{
		//					this.chartList[attr].data[parseInt(val.date)-n]=Number(val[attr])
		//				})
		//				this.ChartData.push(this.chartList[attr])
		//			}
		//			this.defChartMonthOption=function(){//默认月图表参数
		//				let obj={
		//					yTitle:['kWh','CNY','h'],
		//					timeType:"quarter",
		//					opposite:true,
		//					xCategories:new Array(3)
		//				}
		//				$.each(obj.xCategories,function(index){
		//					obj.xCategories[index]= n+index;
		//				});
		//				return obj;
		//			}()
		//		}
		//	},error=>{
		//		lib.loadingChange($("#chartColumn [Loading]"),false);
		//		this.isChart=false
		//		!_.isEmpty(error) && this.$notify(error)
		//	})
		// },
		_getYearData () {
			if (this.detailData.records.length > 0) {
				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				for (let attr in chartData) {
					chartData[attr].data = new Array(12);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					if (chartData[attr].type == 'pr') {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.month) - 1] = Number(val[chartData[attr].type]) * 100;
							}
						});
					} else if (chartData[attr].type == 'cpr') {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.month) - 1] = Number(val[chartData[attr].type]) * 100;
							}
						});
					} else {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.month) - 1] = Number(val[chartData[attr].type]);
							}
						});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) < 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yTitle,
						timeType: 'year',
						opposite: true,
						xCategories: new Array(12)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + 1;
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
		},
		// 年图表数据
		_chartYear () {
			this.$refs.chartColumn.showLoading();
			let requestId;
			let chooseYear = {
				'year': this.time.getFullYear()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			// equipmentApi.cancelRequest()
			equipmentApi.PowerYearHistory(requestId, chooseYear).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'year') { // 防止快速切换导致hideLoading()方法不能执行
					this.resetChart();
					this.isChart = false;
					if (!response) return;
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.detailData = response;
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						this._getYearData();
					}
				}
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				this.isChart = false;
			});
		},
		// 整合总图表数据
		_getTotalData () {
			if (this.detailData.records.length > 0) {
				let startYear = [];
				for (let attr in this.detailData.records) {
					startYear.push(this.detailData.records[attr].year);
				}
				startYear = lib.sortData(startYear)[0]; // 获取最小的年份
				let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
				let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
				this.rangeDate = [new Date(String(startYear)), new Date(endYear)];

				let chartData = [];
				chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
				for (let attr in chartData) {
					chartData[attr].data = new Array(YearNum);
					$.each(chartData[attr].data, (index) => {
						chartData[attr].data[index] = null;
					});
					if (chartData[attr].type == 'pr') {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.year) - Number(startYear)] = Number(val[chartData[attr].type]) * 100;
							} else {
								chartData[attr].data[parseInt(val.year) - Number(startYear)] = val[chartData[attr].type];
							}
						});
					} else {
						this.detailData.records.map((val, index) => {
							if (val[chartData[attr].type] != null) {
								chartData[attr].data[parseInt(val.year) - Number(startYear)] = Number(val[chartData[attr].type]);
							} else {
								chartData[attr].data[parseInt(val.year) - Number(startYear)] = val[chartData[attr].type];
							}
						});
					}
				}
				this.ChartData = chartData;
				let yTitle = [];
				for (let attr in this.ChartData) {
					if (this.ChartData[attr].unit) {
						if (yTitle.indexOf(this.ChartData[attr].unit) < 0) {
							yTitle.push(this.ChartData[attr].unit);
						}
						this.ChartData[attr].yAxis = yTitle.indexOf(this.ChartData[attr].unit);
					}
					delete this.ChartData[attr].default;
					delete this.ChartData[attr].selected;
					delete this.ChartData[attr].type;
				}
				this.defChartMonthOption = (function () { // 默认
					let obj = { // d
						yTitle: yTitle,
						timeType: 'all',
						opposite: true,
						xCategories: new Array(YearNum)
					};
					$.each(obj.xCategories, function (index) {
						obj.xCategories[index] = index + Number(startYear);
					});
					return obj;
				}());
			} else {
				this.ChartData = [];
			}
			// for(let attr in this.chartList){
			//	$.each(this.chartList[attr].data,(index)=>{
			//		this.chartList[attr].data[index]=null
			//	})
			//	this.detailData.records.map((val,index)=>{
			//		this.chartList[attr].data[parseInt(val.year)-Number(startYear)]=Number(val[attr])
			//	})
			//	this.ChartData.push(this.chartList[attr])
			// }
			// this.defChartMonthOption=function(){//默认月图表参数
			//	let obj={ //d
			//		yTitle:['kWh','h','kWh/㎡','%'],
			//		timeType:"all",
			//		opposite:true,
			//		xCategories:new Array(YearNum)
			//	}
			//	$.each(obj.xCategories,function(index){
			//		obj.xCategories[index]=index+Number(startYear);
			//	});
			//	return obj;
			// }()
		},
		// 总图表数据
		_totalData () {
			this.$refs.chartColumn.showLoading();
			let requestId;
			let chooseTotal = {
				'startYear': 2000,
				'endYear': this.time.getFullYear()
			};
			if (this.level == 0) {
				requestId = this.stationId;
			} else {
				requestId = this.systemId;
			}
			// equipmentApi.cancelRequest()
			equipmentApi.PowerTotalHistory(requestId, chooseTotal).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'all') { // 防止快速切换导致hideLoading()方法不能执行
					this.ChartData = [];
					if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
					this.isChart = false;
					if (!response) return;
					this.detailData = response;
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						let startYear = [];
						for (let attr in this.detailData.records) {
							startYear.push(this.detailData.records[attr].year);
						}
						startYear = lib.sortData(startYear)[0]; // 获取最小的年份
						let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
						let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
						this.rangeDate = [new Date(String(startYear)), new Date(endYear)];
						let arrTotal = [
							{
								name: getLanguageStr('word360', '当年发电量'),
								unit: 'kWh',
								type: 'generationValue',
								selected: true,
								isBeingSelected: true,
								default: true,
								data: new Array(YearNum)
							}, {
								name: getLanguageStr('word1734', '当年满发小时'),
								unit: 'h',
								type: 'fullPowerHoursDay',
								selected: false,
								isBeingSelected: false,
								default: false,
								data: new Array(YearNum)
							}, {
								name: getLanguageStr('word1736', '当年辐照量'),
								unit: 'kWh/㎡',
								type: 'irradiate',
								selected: false,
								default: false,
								data: new Array(YearNum)
							}, {
								name: getLanguageStr('plant_detail8', '当年理论发电量'),
								unit: 'kWh',
								type: 'theoreticalGeneration',
								selected: false,
								isBeingSelected: false,
								default: false,
								onlySolarman: true,
								data: new Array(YearNum)
							}, {
								name: getLanguageStr('word1737', '当年PR'),
								unit: '%',
								type: 'pr',
								selected: false,
								default: false,
								data: new Array(YearNum)
							}
						];
						if (this.StationType === 'wind') {
							arrTotal = [{
								name: getLanguageStr('word360', '当年发电量'),
								unit: 'kWh',
								type: 'generationValue',
								selected: true,
								isBeingSelected: true,
								default: true,
								data: new Array(YearNum)
							}, {
								name: getLanguageStr('word1734', '当年满发小时'),
								unit: 'h',
								type: 'fullPowerHoursDay',
								selected: true,
								isBeingSelected: true,
								default: true,
								data: new Array(YearNum)
							}];
						}
						if (this.fromChild == 'childDetail') {
							arrTotal = arrTotal.slice(0, 1);
						}
						this.chartList = arrTotal;
						this._getTotalData();
					}
				}
			}, error => {
				if (this.$refs.chartLine) this.$refs.chartColumn.hideLoading();
				!_.isEmpty(error) && this.$notify(error);
				this.isChart = false;
			});
		},
		_timePicker (item, index) {
			this.$refs.DeviceDetailParam.showParam = false;
			// this.CHANGE(index)
			this.ActiveIndex = index;
			this.$nextTick(() => {
				this._showChart();
			});
		}
	}

};
</script>

<style lang="scss" scoped>
.datepicker {
	width: 125px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/GenerateHistory.vue